import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Gift, X, Copy } from "lucide-react";
import { toast } from "sonner";

export const ReferralBanner = () => {
  const [info, setInfo] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const code = localStorage.getItem("gf_ref");
    if (!code) return;
    if (localStorage.getItem(`gf_ref_dismissed_${code}`)) return;
    api.get("/affiliate/welcome", { params: { code } })
      .then((r) => { if (r.data?.valid) { setInfo({ code, ...r.data }); setShow(true); } })
      .catch(() => {});
  }, []);

  if (!show || !info) return null;
  const dismiss = () => { localStorage.setItem(`gf_ref_dismissed_${info.code}`, "1"); setShow(false); };
  const copy = () => { navigator.clipboard.writeText(info.welcome_coupon); toast.success("Coupon copied!"); };

  return (
    <div data-testid="referral-welcome-banner" className="relative overflow-hidden bg-gradient-to-r from-pink-600 to-rose-500 px-4 py-2.5 text-white">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 pr-6 text-center text-sm font-medium">
        <Gift className="hidden h-4 w-4 shrink-0 sm:block" />
        <span>
          {info.influencer_name ? `${info.influencer_name} invited you! ` : "You've been referred! "}
          {info.welcome_text || (info.welcome_coupon ? "Enjoy a welcome offer on your first order." : "Welcome to Grofkart — happy shopping!")}
        </span>
        {info.welcome_coupon && (
          <button onClick={copy} data-testid="referral-copy-coupon" className="inline-flex items-center gap-1 rounded-lg bg-white/20 px-2.5 py-1 font-mono text-xs font-bold hover:bg-white/30">
            {info.welcome_coupon} <Copy className="h-3 w-3" />
          </button>
        )}
      </div>
      <button onClick={dismiss} data-testid="referral-banner-dismiss" aria-label="Dismiss" className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-1 hover:bg-white/20">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
